var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1465 8.14645C20.3417 7.95118 20.6583 7.95118 20.8536 8.14645L23.8536 11.1464C24.0488 11.3417 24.0488 11.6583 23.8536 11.8536L13.8536 21.8536C13.8057 21.9014 13.7486 21.9391 13.6857 21.9642L8.68571 23.9642C8.5 24.0385 8.28789 23.995 8.14646 23.8536C8.00503 23.7121 7.96149 23.5 8.03578 23.3143L10.0358 18.3143C10.0609 18.2514 10.0986 18.1943 10.1465 18.1464L20.1465 8.14645ZM19.2071 10.5L21.5 12.7929L22.7929 11.5L20.5 9.20711L19.2071 10.5ZM20.7929 13.5L18.5 11.2071L12 17.7071V18H12.5C12.7762 18 13 18.2239 13 18.5V19H13.5C13.7762 19 14 19.2239 14 19.5V20H14.2929L20.7929 13.5ZM11.0317 18.6755L10.9261 18.781L9.39754 22.6025L13.219 21.0739L13.3246 20.9683C13.135 20.8973 13 20.7144 13 20.5V20H12.5C12.2239 20 12 19.7761 12 19.5V19H11.5C11.2856 19 11.1027 18.865 11.0317 18.6755Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0bfcc1ee47f054c8b602cd320f93c1a3.svg";
export { ForwardRef as ReactComponent };